<template>
  <div>
    <div>
      <!--       다폴더         -->
      <div class="slip_bet_ing" style="">
        <div class="slip-scroll">
          <div class="slip-box" :class="{'disable_bet': item.betsStatus === 'y'}" v-for="(item, index) in cartItem" :key="'cartItem'+index">
            <div class="slip_bet_in">
              <div class="slip_bet_row">
                <div class="slip_bet_cell_l">
                  {{ item.homeNameKr || item.homeNameEn }}
                  <span style="color:#da2c36;"> vs </span><br>
                  {{ item.awayNameKr || item.awayNameEn }}
                </div>
                <div class="slip_bet_cell_r">
                  <a @click="deleteItemCart(item)" class="notify-close-btn ">
                    <img src="@/assets/img/ico/ing_close.jpg">
                  </a>
                </div>
              </div>
              <div class="slip_bet_row">
                <div class=" slip_bet_cell_l">{{ item.marketNameKr || item.marketNameEn }}</div>
                <div class="slip_bet_cell_r ">  <i style="color:grey;">({{ item.betsPrevOdds }})</i> </div>
              </div>
              <div class="slip_bet_row">
                <div class="slip_bet_cell_l">
                  <span class="font_002 ">{{ item | cartBetsName }}</span>
                </div>
                <div class="slip_bet_cell_r font_002  ">{{ item.odds }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="slip_bet_table_wrap" style="padding-top: 10px;">
          <div class="bet_table_wrap">
            <div class="bet_table">
              <div class="bet_table_row">
                <div class="bet_table_cell_l" style="color: #c1c3c4;">배당률</div>
                <div id="betPrice" class="bet_table_cell_r">
                  <b><font class="font_002 ng-binding">{{ odds }}</font></b>
                </div>
              </div>
            </div>
            <div class="bet_table">
              <div class="bet_table_row">
                <div class="bet_table_cell_ll" style="color: #c1c3c4; font-size: 12px;">베팅금액</div>
                <div class="bet_table_cell_cc">
                  <input type="text" class="input_style06 ng-pristine ng-untouched ng-valid" style="text-align: right;" v-model="amount">
                </div>
                <div class="bet_table_cell_rr">
                  <a @click="maxBet"><span class="btn10">맥스</span></a>
                </div>
              </div>
            </div>
            <div class="bet_table">
              <div class="bet_table_row">
                <div class="bet_table_cell_l" style="color: #c1c3c4; font-size: 12px;">베팅한도</div>
                <div class="bet_table_cell_r" style="color: #c1c3c4;">
                  <span class="font_002 ng-binding">{{ maxAmount | makeComma }}</span>
                  원
                </div>
              </div>
            </div>
            <div class="bet_table">
              <div class="bet_table_row">
                <div class="bet_table_cell_l" style="color: #c1c3c4;">예상당첨</div>
                <div class="bet_table_cell_r" style="color: #c1c3c4;">
                  <span class="font_002 ng-binding">{{ winnings | makeComma }}</span>
                  원
                </div>
              </div>
            </div>
          </div>
          <ul class="money_ul">
            <li>
              <button @click="addAmount(5000)">5,000원</button>
            </li>
            <li>
              <button @click="addAmount(10000)">10,000원</button>
            </li>
            <li>
              <button @click="addAmount(50000)">50,000원</button>
            </li>
            <li>
              <button @click="addAmount(100000)">100,000원</button>
            </li>
            <li>
              <button @click="addAmount(500000)">500,000원</button>
            </li>
            <li>
              <button @click="addAmount(1000000)">1,000,000원</button>
            </li>
            <li class="red">
              <button @click="maxBet">최대배팅</button>
            </li>
            <li class="red" style="margin: 6px 0 0 6px;">
              <button @click="resetAmount">지우기</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="bet_btn_wrap" style=""><a @click="processBet"><span class="bet_btn">베팅하기</span></a></div>
  </div>
</template>

<script>
import MSG from '@/contants/msg';
import {mapState} from "vuex";

export default {
  name: "Multi",
  props: ['clearCart', 'isUpdate', 'fixed'],
  data: function(){
    return {
      winnings: 0,
      amount: 0,
      maxOddsAmount: 0,
      limitWinnings: 0,
      maxAmount: 0
    }
  },
  computed:{
    odds: function(){
      return Number(this.$store.getters["SPORT_LSPORT_TOTAL_ODDS"])
    },
    levelSetting: function (){
      return this.$store.getters["LEVEL_SETTING"]
    },
    minAmount: function(){
      return Number(this.levelSetting.prematchEuropeanSetting.minBetting);
    },
    maxWinAmount: function(){
      return Number(this.levelSetting.prematchEuropeanSetting.manyOther.maxWin);
    },
    maxNormalBetAmount: function(){
      return Number(this.levelSetting.prematchEuropeanSetting.maxBetting);
    },
    maxOneFolderAmount: function(){
      return Number(this.levelSetting.prematchEuropeanSetting.soloOther.maxBetting);
    },
    maxOneFolderWinning: function(){
      return Number(this.levelSetting.prematchEuropeanSetting.soloOther.maxWin);
    },
    maxOdds: function(){
      return this.levelSetting.prematchEuropeanSetting.maxOdds;
    },
    oneFolderDeduction: function(){
      return this.levelSetting.levelOption.deduction.one;
    },
    twoFolderDeduction: function(){
      return this.levelSetting.levelOption.deduction.two;
    },
    threeFolderDeduction: function(){
      return this.levelSetting.levelOption.deduction.three;
    },
    fourFolderDeduction: function(){
      return this.levelSetting.levelOption.deduction.four;
    },
    fiveFolderDeduction: function(){
      return this.levelSetting.levelOption.deduction.five;
    },
    ...mapState({
      user: state => state.user.user,
      cartItem: state => state.lsport.cart,
    }),
  },
  watch:{
    // 배당변경시 자동으로 최대 가능 베팅금액 변경
    odds: function (val){
      if (Number(this.maxOdds) <= Number(val)) {
        this.cartItem.pop();
        return alert('최대 가능 배당을 초과했습니다.');
      }
      this.calWinnings();
    },
    // 베팅금액 초과시 자동으로 최대 가능 베팅금액 변경
    amount: {
      handler(val){
        if (this.maxAmount < Number(val)) {
          this.amount = this.maxAmount;
          return alert('베팅금액은 최대베팅금액을 초과할 수 없습니다.')
        }
        if (this.user.members_cash < Number(val)) {
          this.amount = this.user.members_cash;
          return alert('베팅금액은 보유금액을 초과할 수 없습니다.')
        }
        this.calWinnings();
      },
      immediate: true,
    },
    cartItem: {
      handler: function(val){
        if (val.length === 0) {
          this.maxAmount = Number(this.maxNormalBetAmount);
        }
        if (val.length === 1) {
          this.maxAmount = Number(this.maxOneFolderAmount);
          this.limitWinnings = this.maxOneFolderWinning;
        }
        if (val.length > 1) {
          this.maxAmount = Number(this.maxNormalBetAmount);
          this.limitWinnings = this.maxWinAmount;
        }
        this.calWinnings();
      },
      immediate: true,
      deep: true,
    },
    // 당첨금 변동
    winnings: function(val){
      if (Number(val) > this.limitWinnings){
        this.amount = Math.floor(this.limitWinnings / this.odds);
        alert(`당첨금액은 ${this.$options.filters.makeComma(this.limitWinnings)}을 초과할 수 없습니다.`)
      }
    }
  },
  methods: {
    deleteItemCart: function(obj){
      return this.$store.dispatch('DELETE_LSPORT_CART_ITEM', obj)
    },
    maxBet: function(){
      const values = [Math.floor(this.limitWinnings/this.odds), this.maxAmount, this.user.members_cash]
      this.amount = Math.min.apply(null, values)
      // 보유금액 * 배당이 limitWinnings에 못미칠때
      // if (this.winnings < this.limitWinnings){
      //   this.amount = Math.floor(this.limitWinnings / this.odds);
      // }
    },
    processBet: function(){
      if (this.user){
        const config = this.user.members_detail_setting;
        if (!config.베팅권한.유럽형.active) return this.$store.dispatch('SHOW_ERR_MSG', MSG.error.authorization);
      } else {
        return this.$store.dispatch('SHOW_ERR_MSG', MSG.error.isNotLogin);
      }
      let data = {};
      if (!this.isActiveFreeBet && this.amount < this.minAmount) return alert(`최소 베팅금은 ${this.$options.filters.makeComma(this.minAmount)}원 입니다.`);
      if (this.cartItem.filter(e=>e.leagueNameEn !== '보너스').length === 1 && ['', 0, '0'].indexOf(this.user.members_detail_setting.베팅차감.스포츠.one) < 0){
        let confirmMsg = `단폴 베팅시 ${this.user.members_detail_setting.베팅차감.스포츠.one}% 배당 하락이 발생합니다.`;
        const oneConfirm = confirm(confirmMsg);
        if (!oneConfirm) {
          return;
        }
        this.betDeduction(this.user.members_detail_setting.베팅차감.스포츠.one, '유저설정-단폴베팅')
      } else {
        if (this.cartItem.filter(e=>e.leagueNameEn !== '보너스').length === 1 && this.oneFolderDeduction) {
          let confirmMsg = `단폴 베팅시 ${this.oneFolderDeduction}% 배당 하락이 발생합니다.`;
          const singleConfirm = confirm(confirmMsg);
          if (!singleConfirm) {
            return;
          }
          this.singleBetDeduction()
        }
      }

      if (
          this.cartItem.filter(e=>e.leagueNameEn !== '보너스').length === 2 && ['', 0, '0'].indexOf(this.user.members_detail_setting.베팅차감.스포츠.two) < 0
      ){
        let confirmMsg = `투폴 베팅시 ${this.user.members_detail_setting.베팅차감.스포츠.two}% 배당 하락이 발생합니다.`;
        const doubleConfirm = confirm(confirmMsg);
        if (!doubleConfirm) {
          return;
        }
        this.betDeduction(this.user.members_detail_setting.베팅차감.스포츠.two, '유저설정-투폴베팅')
      }
      else {
        if (this.cartItem.filter(e=>e.leagueNameEn !== '보너스').length === 2 && this.twoFolderDeduction){
          let confirmMsg = `투폴 베팅시 ${this.twoFolderDeduction}% 배당 하락이 발생합니다.`;
          const doubleConfirm = confirm(confirmMsg);
          if (!doubleConfirm) {
            return;
          }
          this.doubleBetDeduction()
        }
      }

      if (this.cartItem.filter(e=>e.leagueNameEn !== '보너스').length === 3 && ['', 0, '0'].indexOf(this.user.members_detail_setting.베팅차감.스포츠.three) < 0){
        let confirmMsg = `세폴 베팅시 ${this.user.members_detail_setting.베팅차감.스포츠.three}% 배당 하락이 발생합니다.`;
        const doubleConfirm = confirm(confirmMsg);
        if (!doubleConfirm) {
          return;
        }
        this.betDeduction(this.user.members_detail_setting.베팅차감.스포츠.three, '유저설정-세폴베팅')
      }

      if (
          this.cartItem.filter(e=>e.leagueNameEn !== '보너스').length > 3 &&
          this.user.is_discount_three_over === 'Y'
      ){
        let confirmMsg = `세폴 베팅 초과시 ${this.user.members_detail_setting.베팅차감.스포츠.three}% 배당 하락이 발생합니다.`;
        const doubleConfirm = confirm(confirmMsg);
        if (!doubleConfirm) return;
        this.betDeduction(this.user.members_detail_setting.베팅차감.스포츠.three, '유저설정-세폴초과베팅')
      }

      data.bettings = this.cartItem;
      data.amount = this.amount;
      data.totalOdds = this.odds;
      data.winnings = this.winnings;
      console.log(data);
      this.$store.dispatch('SET_PROCESS', data);
      if (this.odds > this.maxOdds) return this.$store.dispatch('SHOW_ERR_MSG', '최대 배당을 초과하여 베팅할 수 없습니다.')


      if (this.cartItem.find(b => b.betsStatus === 'y')){
        this.$store.dispatch('SET_ERR_MSG', MSG.notAvailableBet);
        this.$store.dispatch('SHOW_MODAL', 'bettingStatus');
        return;
      }

      if (!this.isUpdate && this.cartItem.find(e => String(e.betsPrevOdds) !== String(e.odds) && e.betType !== '보너스')){
        this.$store.dispatch('SHOW_MODAL', 'bettingUpdate')
        return;
      }

      if (this.isUpdate && this.cartItem.find(e => String(e.betsPrevOdds) !== String(e.odds) && e.betType !== '보너스')){
        this.$store.dispatch('SHOW_MODAL', 'bettingUpdateProcess')
        return;
      }

      console.log('엘스포츠 유럽형 멀티')
      this.$store.dispatch('SHOW_MODAL', 'bettingProcessLsportEuropeanMulti')
      //다폴더

      this.amount = 0;
      this.clearCart();
    },
    calWinnings: function (){
      this.winnings = Math.floor(this.amount * this.odds);
    },
    addAmount(amt){
      this.amount += amt;
    },
    resetAmount(){
      this.amount = 0;
    },
    betDeduction:function(penalty, reason){
      for (const c in this.cartItem){
        this.cartItem[c].penalty = penalty;
        this.cartItem[c].penaltyReason = reason;
      }
    },
    singleBetDeduction:function(){
      for (const c in this.cartItem){
        this.cartItem[c].penalty = this.oneFolderDeduction;
        this.cartItem[c].penaltyReason = '단폴 베팅';
      }
    },
    doubleBetDeduction:function(){
      for (const c in this.cartItem){
        this.cartItem[c].penalty = this.twoFolderDeduction;
        this.cartItem[c].penaltyReason = '투폴 베팅';
      }
    },
    tripleBetDeduction:function(){
      for (const c in this.cartItem){
        this.cartItem[c].penalty = '0.04';
        this.cartItem[c].penaltyReason = '세폴이상 베팅';
      }
    },
  }
}
</script>

<style scoped>
.moneys a { width:33.333%; border-right:1px solid #263c43; border-bottom: 1px solid #263c43; box-sizing: border-box; line-height: 30px; font-size:14px; color:rgba(255,255,255,0.7); text-align: center; transition: all 0.5s ease; }
.moneys a:hover { background: #fff; color: #222; font-weight: 600;}
</style>
